/**
 * computeInitials — iniziali "umane" per gli avatar circolari (card autore,
 * nodi del grafo influenze e della mappa temi).
 *
 * Prende l'iniziale delle prime DUE parole con iniziale MAIUSCOLA, così
 * articoli/preposizioni minuscoli e la punteggiatura vengono ignorati:
 *   "Geoffrey Chaucer"             → "GC"
 *   "William Shakespeare"          → "WS"
 *   "Anonymous (the Beowulf poet)" → "AB"   (prima era "A(")
 *
 * Fallback: una sola parola maiuscola → prime 2 lettere; nessuna → prime 2
 * lettere qualsiasi; stringa senza lettere → "?".
 *
 * UNICA fonte di verità: prima esistevano 3 copie divergenti (AuthorListView,
 * InfluenceGraphView, ThemeMapView) tutte con lo stesso bug sui `(`.
 */
export function computeInitials(name: string): string {
  const caps = name.match(/\p{Lu}[\p{L}']*/gu) ?? [];
  if (caps.length >= 2) return (caps[0]!.charAt(0) + caps[1]!.charAt(0)).toUpperCase();
  if (caps.length === 1) return caps[0]!.slice(0, 2).toUpperCase();
  const letters = (name.match(/\p{L}/gu) ?? []).slice(0, 2).join('');
  return letters.toUpperCase() || '?';
}
